import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { WALLET_ACTION_TYPE } from "./wallet.action";
import {
	AamsBalances,
	AamsBalancesPayload,
	Balance,
	Balances,
	BetWinSummary,
	Transaction,
	TransactionDetail,
	TransactionTotalsResponse,
	WalletState,
	WithdrawalRestrictions,
} from "./wallet.model";

const initialState: WalletState = {};

export function walletReducer(state = initialState, action: ActionWithPayload): WalletState {
	switch (action.type) {
		case WALLET_ACTION_TYPE.getBalanceSuccess: {
			if ("availableToWithdraw" in (action.payload as AamsBalancesPayload | Balances)) {
				const aamsBalance = action.payload as AamsBalancesPayload;
				const totalAmount =
					(aamsBalance.availableToWithdraw?.amount ?? 0.0) +
					(aamsBalance.lockedMoney?.amount ?? 0.0) +
					(aamsBalance.realBonusMoney?.amount ?? 0.0) +
					(aamsBalance.specialBonusMoney?.amount ?? 0.0);

				return updateState(state, {
					aamsBalance: {
						availableToWithdraw: aamsBalance.availableToWithdraw,
						lockedMoney: aamsBalance.lockedMoney,
						realBonusMoney: aamsBalance.realBonusMoney,
						specialBonusMoney: aamsBalance.specialBonusMoney,
						totalAmount,
						currencyCode: aamsBalance.availableToWithdraw?.currencyCode,
					},
					aamsBonusContextBalances: (action.payload as AamsBalances).bonusContextBalances,
				});
			}
			return updateState(state, action.payload as Balances);
		}
		case WALLET_ACTION_TYPE.getBetWinSummarySuccess: {
			return updateState(state, {
				betWinSummary: action.payload as BetWinSummary,
			});
		}
		case WALLET_ACTION_TYPE.getTransactionSuccess: {
			return updateState(state, {
				transaction: action.payload as TransactionDetail,
			});
		}
		case WALLET_ACTION_TYPE.getTransactionsSuccess: {
			return updateState(state, {
				transactions: action.payload as Transaction,
			});
		}
		case WALLET_ACTION_TYPE.getTransactionTotalsSuccess: {
			const response = action.payload as TransactionTotalsResponse;
			const transactionTotals = state.transactionTotals || {};
			transactionTotals[response.id] = response.result;

			return updateState(state, {
				transactionTotals,
			});
		}
		case WALLET_ACTION_TYPE.clearTransactions: {
			return updateState(state, {
				transactionTotals: undefined,
				transactions: undefined,
			});
		}
		case WALLET_ACTION_TYPE.updateCurrentProductBalance: {
			return updateState(state, {
				currentProductBalance: action.payload as Balance | undefined,
			});
		}
		case WALLET_ACTION_TYPE.getWithdrawalRestrictionsSuccess: {
			return updateState(state, {
				withdrawalRestriction: action.payload as WithdrawalRestrictions,
			});
		}
		case WALLET_ACTION_TYPE.reset: {
			return initialState;
		}
		default:
			return state;
	}
}
